function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import { Burger } from './Burger';
import React from 'react';
export var Fade = function Fade(props) {
  return /*#__PURE__*/React.createElement(Burger, _extends({}, props, {
    render: function render(o) {
      return /*#__PURE__*/React.createElement("div", {
        className: "hamburger-react",
        "aria-label": o.label,
        "aria-expanded": o.isToggled,
        onClick: o.handler,
        onKeyUp: function onKeyUp(e) {
          return e.key === 'Enter' && o.handler();
        },
        role: "button",
        style: o.burgerStyles,
        tabIndex: 0
      }, /*#__PURE__*/React.createElement("div", {
        style: _objectSpread(_objectSpread({}, o.barStyles), {}, {
          width: "".concat(o.width, "px"),
          top: "".concat(o.topOffset, "px"),
          transition: "".concat(o.time, "s ").concat(o.easing),
          transform: "".concat(o.isToggled ? "rotate(".concat(45 * (o.isLeft ? -1 : 1), "deg) translate(").concat(o.move * (o.isLeft ? -1 : 1), "px, ").concat(o.move, "px)") : 'none')
        })
      }), /*#__PURE__*/React.createElement("div", {
        style: _objectSpread(_objectSpread({}, o.barStyles), {}, {
          width: "".concat(o.width, "px"),
          top: "".concat(o.topOffset + o.barHeight + o.margin, "px"),
          transition: "".concat(o.time, "s ").concat(o.easing),
          opacity: "".concat(o.isToggled ? '0' : '1')
        })
      }), /*#__PURE__*/React.createElement("div", {
        style: _objectSpread(_objectSpread({}, o.barStyles), {}, {
          width: "".concat(o.width, "px"),
          top: "".concat(o.topOffset + o.barHeight * 2 + o.margin * 2, "px"),
          transition: "".concat(o.time, "s ").concat(o.easing),
          transform: "".concat(o.isToggled ? "rotate(".concat(45 * (o.isLeft ? 1 : -1), "deg) translate(").concat(o.move * (o.isLeft ? -1 : 1), "px, ").concat(o.move * -1, "px)") : 'none')
        })
      }));
    }
  }));
};